import React from 'react';
import Input from './Input';
import Label from './Label';

const SearchBar = ({ value, onChange, placeholder, labelText, widthClass, inputClass = '' }) => {
  const containerClasses = widthClass || 'w-full';

  return (
    <div className={`flex flex-col ${containerClasses}`}>
      <Label variant="dark">{labelText}</Label>
      <Input
        variant="secondary"
        type="text"
        id="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        customClass={inputClass}
      />
    </div>
  );
};

export default SearchBar;
